import { PropsWithChildren } from "react";
import { useGameConfiguration } from "@/state/cacheStoreHooks";
import PhoneFrameButtons from "@/components/layout/PhoneFrameButtons";
import { useFullscreen } from "@/hooks/useFullscreen";
import clsx from "clsx";
import DoubleArrowIcon from "@/components/icons/DoubleArrowIcon";
import { LandscapeWarningOverlay } from "@/components/screens/LandscapeWarningOverlay";
import { StrapiMedia } from "@/components/shared/StrapiMedia";

type Props = PropsWithChildren & {
    restrictWidth?: boolean;
};

export const AppBaseLayout = ({ children }: Props) => {
    const gameConfig = useGameConfiguration();
    const { isFullscreen, exit: exitFullscreen, request: requestFullscreen } = useFullscreen();

    return (
        <>
            <LandscapeWarningOverlay />
            <div className="viewport-container md:flex md:items-center md:justify-center md:bg-neutral-900">
                {/* Phone frame background - blurred, so thumbnail quality is sufficient */}
                {gameConfig?.SplashImage && (
                    <div className="hidden md:block absolute inset-0 z-0">
                        <StrapiMedia
                            size="sm"
                            image={gameConfig.SplashImage}
                            className="w-full h-full object-cover -scale-x-100 blur-[64px]"
                            alt=""
                            aria-hidden="true"
                        />
                    </div>
                )}

                <button
                    onClick={isFullscreen ? exitFullscreen : requestFullscreen}
                    className={clsx(
                        "hidden md:flex fixed top-4 right-4 z-50 cursor-pointer rounded-full p-3",
                        "text-white transition-colors  border border-gray-500/35 bg-black/10 hover:bg-black/15 ",
                    )}
                >
                    <DoubleArrowIcon direction={isFullscreen ? "collapse" : "expand"} />
                </button>

                <div className="relative z-10 md:w-[360px] md:h-[640px] size-full">
                    <PhoneFrameButtons />
                    <div
                        className="
                            shadow-[0px_32px_64px_0px_rgba(0,0,0,0.65)]
                            h-full w-full
                            md:rounded-[3rem]
                            md:border-[10px] md:border-phone-frame
                            md:box-content
                            md:shadow-[0_0_60px_rgba(0,0,0,0.5)]
                            md:overflow-hidden
                            relative
                            will-change-transform
                        "
                    >
                        <div className="h-full w-full overflow-hidden bg-white">{children}</div>
                    </div>
                </div>
            </div>
        </>
    );
};
